// extracted by mini-css-extract-plugin
module.exports = {"banner_container":"style_banner_container__1wlIK","banner_title":"style_banner_title__3e1Lq"};